import { Alpine } from "alpinejs";

// for scanning products into orders used: templates/scan/order
function scanOrderProducts() {
    async function postData(formData) {
        let url = window.location.origin + '/actions/';
        let response = await fetch(url + formData.get('action'), {
            method:'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept':'application/json',
                'mode':'same-origin'
            },
            body: JSON.stringify(Object.fromEntries(formData.entries())),
        });
        return response.json();
    }
    return {
        scanData: {},
        errorNotification: false,
        notificationIcon: `<svg class="w-5 h-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" /></svg>`,
        notificationTitle: null,
        notificationText: null,
        submit($event) {
            $event.preventDefault();
            let $form = $event.target;
            let formData = new FormData($form); 
            let response = postData(formData)
                .then(result => {
                    // console.log(result['complete']);
                    if (result['complete'] !== undefined) {
                        this.scanData = result;
                        if (this.scanData['complete']) {
                            window.location.reload();
                        } else {
                            // console.log(this.scanData['complete']);
                            $form.querySelector('input[name="barcode"]').value = '';
                        }
                    } else if (result['error']) {
                        this.errorNotification = true;
                        this.notificationTitle = 'Error!';
                        this.notificationText = result['error'];
                    } else {
                        console.error('Response Data:', result);
                        this.errorNotification = true;
                        this.notificationTitle = 'Error!';
                        this.notificationText = 'Unknown error has occurred please check console or request help.';
                    }
                    
                }).catch(error => {
                    console.error('Error:', error);
                    this.errorNotification = true;
                    this.notificationTitle = 'Error!';
                    this.notificationText = 'Unknown error has occurred please check console or request help.';
                    
            });
        },
        lineItemQty(lineItemId) {
            if (lineItemId in this.scanData) {
                return this.scanData[lineItemId]['scannedQty'];
            } else {
                return 0;
            }
        },
        lineItemCompleteIcon(lineItemId,expectedQty) {
            if (this.lineItemQty(lineItemId) == expectedQty) {
                return `<svg class="w-6 h-6 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" /></svg>`;
            } else {
                return '';
            }
        }
    }
}

// used to select/deselect orders for printing, builds query params for print page: templates/print/list.twig
function printTable() {
    return {
        orderStatus: '',
        orderStatuses: ['pending','processing','back-order'],
        checkedOrders: [],
        printClicked: false,
        canPrint() {
            return ['pending','back-order'].indexOf(this.orderStatus) !== -1;
        },
        canProcess() {
            return  this.canPrint() && this.printClicked;
        },
        canShip() {
            return this.orderStatus == 'processing';
        },
        selectedTotal() { return this.checkedOrders.length },
        generateUrl(baseUrl) { 

            let params = new URLSearchParams({'ids':this.checkedOrders});
            return baseUrl + '?' + params; 
        },
        toggleAll($el,$event) {
            let checkAllInput = $event.target;
            let inputs = $el.querySelectorAll('input[name="selected"]');
            this.checkedOrders = [];
            inputs.forEach(input => {
                input.checked = checkAllInput.checked;
                if (input.checked) {
                    this.checkedOrders.push(input.value);
                }
            });

        },
        setContext(orderStatus) {
            if (this.orderStatuses.indexOf(orderStatus) !== -1 ) {
                this.orderStatus = orderStatus;
            }
        }
    }
}

// used for checking in products to locations on templates/scan/check-in.twig
// consider an update all button that runs form submit for all
const stockUpdate = function() {
    async function postData(formData) {
        let url = window.location.origin + '/actions/';
        let response = await fetch(url + formData.get('action'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept':'application/json',
                'mode':'same-origin'
            },
            body: JSON.stringify(Object.fromEntries(formData.entries())),
        });
        return response.json();    
    }
    return {
        currentStocks: {},
        errorNotification: false,
        notificationTitle: '',
        notificationText: '',
        notificationIcon: '',
        buildStockObj($parent) {
            let locations = $parent.querySelectorAll("td[data-handle]");
            locations.forEach((location) => {
                // console.log(location)
                this.currentStocks[location.dataset.handle] = location.dataset.qty
            });
        },
        formSubmit($event) {
            $event.preventDefault();
            let $form = $event.target;
            let formData = new FormData($form); 
            let response = postData(formData)
                .then(result => {
                    this.currentStocks[result.location] = result.totalQty;  
                    this.errorNotification = true;
                    this.notificationTitle = 'Success!';
                    this.notificationText = `${result.qty} items of ${result.purchasable.description} added to ${result.location.toUpperCase()}`;   
                    this.notificationIcon = `<svg class="w-5 h-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" /></svg>`;       
                    $form.reset();     
                }).catch(error => {
                    console.error('Error:', error);
                    this.errorNotification = true;
                    this.notificationTitle = 'Error!';
                    this.notificationText = 'Unknown error has occurred please check console or request help.';
                    this.notificationIcon = `<svg class="w-5 h-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" /></svg>`;
                });
        }
    }
}

// Assign alpine functions to window as per: https://github.com/alpinejs/alpine/#x-data
window.scanOrderProducts = scanOrderProducts();
window.printTable = printTable();
window.stockUpdate = stockUpdate;